import { rest } from 'msw'
import { log } from '@ecommerce/shared'
import { CreatePaymentResponseYape } from '@ecommerce/shared/src/services/BFF/utils'
import { ConfirmPaymentResponse } from '@ecommerce/shared/src/services/BFF/types'
import config from '@ecommerce/shared/src/config'
import { mockConfig } from './mockConfig'

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const handlers = [
  rest.post(`${config.CUSTOMER_BFF_HOST}/payments/create`, async (req, res, ctx) => {
    await delay(mockConfig.payments.delay)
    log.info(req)

    // @ts-ignore
    const { orderId, country, paymentOptionId, paymentOptionName, paymentOptionData } = req.body

    log.info('🔶 Mock createPayment called with:', {
      orderId,
      country,
      paymentOptionId,
      paymentOptionName,
      paymentOptionData,
    })

    if (mockConfig.payments.shouldFail) {
      return res(
        ctx.status(500),
        ctx.json({
          statusCode: 500,
          message: 'Internal server error',
          error: 'Server Error',
        }),
      )
    }

    if (paymentOptionName === 'Yape') {
      const response: CreatePaymentResponseYape = {
        message: 'Payment created successfully',
        confirm: {
          data: {
            authorizationNumber: `${mockConfig.payments.authPrefix}${Date.now().toString().slice(-6)}`,
          },
          state: 1,
          message: 'Confirmation pending',
        },
      }

      return res(ctx.delay(200), ctx.status(200), ctx.json(response))
    }

    return res(
      ctx.delay(200),
      ctx.status(200),
      ctx.json({
        payment_id: `payment-${Date.now()}`,
        payment_url: 'https://example.com/payment',
        qr:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==',
      }),
    )
  }),

  rest.post(`${config.CUSTOMER_BFF_HOST}/payments/confirm`, async (req, res, ctx) => {
    await delay(mockConfig.payments.delay)

    // @ts-ignore
    const { authorizationNumber, country, otp, orderId } = await req.body

    log.info('🔶 Mock confirmPayment called with:', {
      authorizationNumber,
      country,
      otp,
      orderId,
    })

    if (mockConfig.payments.shouldFail) {
      return res(
        ctx.status(500),
        ctx.json({
          statusCode: 500,
          message: 'Internal server error',
          error: 'Server Error',
        }),
      )
    }

    if (otp !== mockConfig.payments.otp) {
      return res(
        ctx.status(400),
        ctx.json({
          statusCode: 400,
          message: 'Código ingresado no existe',
          error: 'Bad Request',
        }),
      )
    }

    const response: ConfirmPaymentResponse = {
      statusCode: 200,
      message: 'Payment confirmed successfully',
      error: '',
    }

    return res(ctx.delay(200), ctx.status(200), ctx.json(response))
  }),
]
